const ENV = process.env.REACT_APP_ENV;

export const DEFAULT_REFERENTIALS_CLIENT = ['external', 'internal'];

export const TTC_REFERENTIALS = ['easyreprise', 'psa', 'psa_profil'];
export const HT_REFERENTIALS = ['psa_ht_cession'];
// difference in hours between now and last modified form date for deletion
export const MAX_INTERVALE_DELETE_FORM = 2;

// difference in hours between now and last modified form date for deletion
export const MAX_SIMULTANEOUS_IMAGES_DOWNLOAD = 10;

// Expires cookies 15 days
export const EXPIRES_COOKIE = 15;

// expire refresh token
export const EXPIRES_COOKIE_RTOKEN = 30;
// expire access token
export const EXPIRES_COOKIE_ATOKEN = 1 / 25; // less than 1 hour

// API urls
const apiCarcheck = {
  dev: 'https://api-carcheck.shakazoola.local/v1',
  staging: 'https://stg-api-carcheck.shakazoola.com/v1',
  ppr: 'https://ppr-api-carcheck.shakazoola.com/v1',
  prod: 'https://api-carcheck.autobiz.com/v1',
};
const apiReferential = {
  dev: 'https://stg-api.shakazoola.com/referential/v1',
  staging: 'https://stg-api.shakazoola.com/referential/v1',
  ppr: 'https://ppr-api.shakazoola.com/referential/v1',
  prod: 'https://apiv2.autobiz.com/referential/v1',
};
const apiCostReferential = {
  dev: 'https://wj30j63lc7.execute-api.eu-west-1.amazonaws.com/DEV',
  staging: 'https://wj30j63lc7.execute-api.eu-west-1.amazonaws.com/PREPROD',
  ppr: 'https://wj30j63lc7.execute-api.eu-west-1.amazonaws.com/PREPROD',
  prod: 'https://wj30j63lc7.execute-api.eu-west-1.amazonaws.com/PROD',
};
const apiQuotation = {
  dev: 'https://stg-api.shakazoola.com/quotation/v1',
  staging: 'https://stg-api.shakazoola.com/quotation/v1',
  ppr: 'https://ppr-api.shakazoola.com/quotation/v1',
  prod: 'https://apiv2.autobiz.com/quotation/v1',
};

const apiAccount = {
  dev: 'https://stg-accounts.shakazoola.com/api',
  staging: 'https://stg-accounts.shakazoola.com/api',
  ppr: 'https://ppr-accounts.shakazoola.com/api',
  prod: 'https://accounts.autobiz.com/api',
};

const apiOffice = {
  dev: 'https://stg-office-api.shakazoola.com',
  staging: 'https://stg-office-api.shakazoola.com',
  ppr: 'https://ppr-office-api.autobiz.com',
  prod: 'https://office-api.autobiz.com',
};

const easyRepriseGroupId = {
  dev: 1,
  staging: 1,
  ppr: 7,
  prod: 7,
};

export const KEY_API_COST_REFERENTIAL = 'IOld6xHtEs28hTtMRYGzFLND1VMUaYDaSsB7vLUj';

export const REACT_APP_API = apiCarcheck[ENV];
export const REACT_APP_APIREFERENTIAL = apiReferential[ENV];
export const REACT_APP_APICOSTREFERENTIAL = apiCostReferential[ENV];
export const REACT_APP_APIQUOTATION = apiQuotation[ENV];
export const REACT_APP_APIOFFICE = apiOffice[ENV];
export const ER_GROUP_ID = easyRepriseGroupId[ENV];

const sentryConfig = {
  dev: {},
  staging: { token: 'b0315c83b43d41508a0db7406712dc28', id: 3 },
  ppr: { token: '373bcf501aaf4bc8a164b4d7c4e08ac9', id: 4 },
  prod: { token: '373bcf501aaf4bc8a164b4d7c4e08ac9', id: 4 },
};

export const REACT_APP_SENTRY_CONFIG = sentryConfig[ENV];

export const STATUS = {
  new: 1,
  in_progress: 2,
  appraisal_stopped: 3,
  saved: 4,
  completed: 5,
  submitted: 6,
  report_available: 7,
};

export const RECORD_STATUS = {
  record_init: 0,
  expertise_restarted: 1,
  expertise_started: 2,
  expertise_finished: 3,
  expertise_authorized: 4,
  auto_accept: 5,
  supervisor_refused: 6,
  refused: 7,
  report: 8,
  transaction: 9,
  finish: 10,
  closed: 11,
  expertise_interrupted: 12,
  justified: 13,
  report_ongoing: 14,
  old_flow: 15,
  repurchase_account: 16,
  outdated: 17,
  appointment_planned: 18,
  appointment_canceled: 19,
  not_show: 20,
  come_left: 21,
  waiting_for_counter_appraisal:30,
  counter_appraisal_ongoing:35,
  counter_appraisal_verification:40,
  };
export const NRM_SUB_STATUS = {
  onGoingNrm: 0,
  pricingInProgress: 1,
  tradeInPriceProposed: 5,
  noTradeInPriceProposed: 10,
  tradeInLinkedToNcNotConfirmedByClient: 15,
  tradeInExpired: 20,
  tradeInConfirmedByClient: 25,
  tradeInWithOrderId: 30,
  tradeInCancelled: 35,
  waitingForCounterAppraisal: 40,
  counterAppraisalVerification: 45,
  tradeInMaintainedPriceMaintained: 50,
  tradeInMaintainedPriceModified: 55,
  finalizationCompleted: 60,
  finalizationAccepted: 65,
};
export const CANCEL_CASE = {
  cancelAfterPriceMaintained:1,
  cancelAfterPriceModified: 2,
  cancelAfterWaitingForCounterAppraisal: 3,
  cancelAfterWaitingForCounterAppraisalRealDeliveryDate: 4,
  cancelAfterCounterAppraisalVerification: 5,
  cancelAfterFinalisationVerification: 6,
};
export const NRM_FIRM_STATUS = {
  ongoing: 1,
  validated: 5,
  cancelled: 10,
  confirmed: 15,
};

export const cancleCases = {
  cancelAfterPriceMaintained: 1,
  cancelAfterPriceModified: 2,
  cancelAfterWaitingForCounterAppraisal: 3,
  cancelAfterWaitingForCounterAppraisalRealDeliveryDate: 4,
  cancelAfterCounterAppraisalVerification: 5,
  cancelAfterFinalisationVerification: 6,
}

export const remoteRecordStatus = [
  RECORD_STATUS.expertise_authorized,
  RECORD_STATUS.expertise_finished,
  RECORD_STATUS.supervisor_refused,
  RECORD_STATUS.refused,
  RECORD_STATUS.expertise_interrupted,
];

export const statusGroups = {
  appointment_planned: ['appointment_planned'],
  ongoing_inspection: ['expertise_started', 'expertise_restarted'],
  pricing_made: ['expertise_authorized', 'auto_accept'],
  ongoing_transaction: ['transaction', 'finish'],
  purchased: ['justified', 'repurchase_account'],
  outside_process: [
    'supervisor_refused',
    'refused',
    'expertise_interrupted',
    'not_show',
    'come_left',
    'report',
    'outdated',
    'appointment_canceled',
  ],
};

// rules
export const RULES_AUTHORIZED = ['adminCarcheck', 'managerCarcheck', 'buyerCarcheck', 'viewer'];

export const LOCALSTATUS = {
  synchronized: 0,
  updated: 1,
  to_send: 2,
  sending: 3,
  error_network: 98,
  error_post_form: 99,
  tmp_form: 100,
};

export const INTERVAL_CLEAN_FORMS = 5000; // ms

const staticContents = {
  dev: 'https://carcheck-autobiz-dev.s3-eu-west-1.amazonaws.com/staticContent',
  staging: 'https://carcheck-autobiz-dev.s3-eu-west-1.amazonaws.com/staticContent',
  ppr: 'https://carcheck-autobiz-ir.s3-eu-west-1.amazonaws.com/staticContent',
  prod: 'https://carcheck-autobiz-ir.s3-eu-west-1.amazonaws.com/staticContent',
};

export const staticContentUrl = staticContents[ENV];
export const staticCache = 'static-content';
export const staticFiles = {
  //locale: 'locale.json',
  help: 'help.html',
  contact: 'contact.html',
  infos: 'infos.html',
};

export const IMAGE_MAX_SIZE = 2500;
export const IMAGE_QUALITY = 0.7; // 0-1
export const IMAGE_STANDARD_SIZE = 1200;
export const IMAGE_STANDARD_QUALITY = 0.7;

const apiPostError = {
  dev: 'https://f5rqz22zy2.execute-api.eu-west-1.amazonaws.com/DEV',
  staging: 'https://f5rqz22zy2.execute-api.eu-west-1.amazonaws.com/PREPROD',
  ppr: 'https://f5rqz22zy2.execute-api.eu-west-1.amazonaws.com/PREPROD',
  prod: 'https://f5rqz22zy2.execute-api.eu-west-1.amazonaws.com/PROD',
};
export const API_POST_ERROR = apiPostError[ENV];

// group confession id qui sont autorizé
export const ROLE_ID = {
  1: 'buyer',
  2: 'manager',
  3: 'admin',
  4: 'supervisor',
  5: 'superAdmin',
  6: 'multiSupervisor',
  7: 'viewer',
};

export const DISPLAY_REFERENTIALS = {
  carcheck: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  ald: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  spoticar_citroen_hbs: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  spoticar_peugeot_hbs: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  carventura: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  psar: {
    buyer: ['psa_ht_cession'],
    manager: ['psa', 'psa_ht_cession'],
  },
  mobile: {
    buyer: ['mobile'],
    manager: ['mobile'],
  },
  gaap: {
    buyer: ['easyreprise'],
    manager: ['easyreprise'],
  },
  test: {
    buyer: ['easyreprise'],
    manager: ['easyreprise'],
  },
  porsche: {
    buyer: ['porsche_external', 'porsche_internal'],
    manager: ['porsche_external', 'porsche_internal'],
  },
  pautric: {
    buyer: ['pautric_external', 'pautric_internal'],
    manager: ['pautric_external', 'pautric_internal'],
  },
  porsche_pt: {
    buyer: ['porsche_external', 'porsche_internal'],
    manager: ['porsche_external', 'porsche_internal'],
  },
  gruppobossoni: {
    buyer: ['bossoni_external', 'bossoni_internal'],
    manager: ['bossoni_external', 'bossoni_internal'],
  },
  vwrgroup: {
    buyer: ['vwr_external', 'vwr_internal'],
    manager: ['vwr_external', 'vwr_internal'],
  },
  grupo_auracar: {
    buyer: ['auracar_external', 'auracar_internal'],
    manager: ['auracar_external', 'auracar_internal'],
  },
  huertas_gines_huertas_cervantes: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_huertas_center: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  'huertas_a.caravaca': {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  'huertas_com.labasa': {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_labasa: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_usacar: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_dimovil: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_motor_cartagena: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_comercial_dimovil: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_huertasmotor01: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  huertas_huertasmotor02: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  gines_huertas_industriales: {
    buyer: ['huertas_external', 'huertas_internal'],
    manager: ['huertas_external', 'huertas_internal'],
  },
  gruppoporsche: {
    buyer: ['porsche_it_external', 'porsche_it_internal'],
    manager: ['porsche_it_external', 'porsche_it_internal'],
  },
  dbf: {
    buyer: ['dbf_fr_external', 'dbf_fr_internal'],
    manager: ['dbf_fr_external', 'dbf_fr_internal'],
  },
  gruppoeurotarget: {
    buyer: ['eurotarget_it_external', 'eurotarget_it_internal'],
    manager: ['eurotarget_it_external', 'eurotarget_it_internal'],
  },
  gruppograndiauto: {
    buyer: ['grandiauto_it_external', 'grandiauto_it_internal'],
    manager: ['grandiauto_it_external', 'grandiauto_it_internal'],
  },
  hbs_spoticar_fr: {
    buyer: ['easyreprise', 'psa_ht_cession'],
    manager: ['easyreprise', 'psa_ht_cession'],
  },
  default: {
    buyer: ['external', 'internal'],
    manager: ['external', 'internal'],
  },
};

export const regexRegistration = {
  FR: '^[a-zA-Z0-9]{7,9}$',
  PT: '^[a-zA-Z0-9]{6}$',
  default: '^[A-Za-z0-9]{4,11}$',
};

export const datesFormat = {
  DE: 'dd.MM.yyyy',
  default: 'dd/MM/yyyy',
};

// To be confirmed with Benoit
const autobizTradeSiteUrls = {
  dev: 'https://stg-trade.shakazoola.com',
  staging: 'https://stg-trade.shakazoola.com',
  ppr: 'https://ppr-trade.shakazoola.com',
  prod: 'https://trade.autobiz.com',
};

const autobizMarketUrls = {
  dev: 'https://market.shakazoola.com',
  staging: 'https://market.shakazoola.com',
  ppr: 'https://www.autobiz-market.com',
  prod: 'https://www.autobiz-market.com',
};
export const autobizMarketUrl = autobizMarketUrls[ENV];

const autobizMarketUrlsV2 = {
  dev: 'https://stg-market.shakazoola.com/analyse',
  staging: 'https://stg-market.shakazoola.com/analyse',
  ppr: 'https://ppr-market.shakazoola.com/analyse',
  prod: 'https://market.autobiz.com/analyse',
};
export const autobizMarketUrlV2 = autobizMarketUrlsV2[ENV];

const autobizOfficeUrls = {
  dev: 'https://stg-office-connect.shakazoola.com',
  staging: 'https://stg-office-connect.shakazoola.com',
  ppr: 'https://ppr-office-connect.autobiz.com',
  prod: 'https://office-connect.autobiz.com',
};
export const autobizOfficeUrl = autobizOfficeUrls[ENV];

const autobizMarketEsUrls = {
  dev: 'https://recette.sistemavo.es',
  staging: 'https://recette.sistemavo.es',
  ppr: 'http://www.sistemavo.es',
  prod: 'http://www.sistemavo.es',
};

export const autobizMarketEsUrl = autobizMarketEsUrls[ENV];

export const autobizTradeSiteUrl = autobizTradeSiteUrls[ENV];

const autobizLeadsUrls = {
  dev: 'https://stg-leads.shakazoola.com',
  staging: 'https://stg-leads.shakazoola.com',
  ppr: 'https://ppr-leads.autobiz.com',
  prod: 'https://leads.autobiz.com',
};
export const autobizLeadsUrl = autobizLeadsUrls[ENV];

export const listTVA = {
  FR: 1.2,
  ES: 1.21,
  IT: 1.22,
  DE: 1.19,
  PT: 1.23,
  NL: 1.23,
  BE: 1.23,
  AT: 1.23,
};

const publicGroup = {
  dev: '1efc90ed-4a62-6a0a-bdea-aff9e568f7fb',
  staging: '1efc90ed-4a62-6a0a-bdea-aff9e568f7fb',
  ppr: '1efdc99f-73b2-61d0-8167-3f73b3466a54',
  prod: '1f01f893-17e5-6358-9aed-3dce1a1638f9',
};
export const REACT_APP_PUBLIC_GROUP_CONFIG = publicGroup[ENV];

const nationalPublicGroup = {
  dev: {
    FR: '1efc90ed-4aae-6e50-bdea-aff9e568f7fb',
    ES: '1efc90ef-9fd6-6002-bdea-aff9e568f7fb',
    IT: '1efc90ed-ac3e-6012-bdea-aff9e568f7fb',
    PT: '1efc90ef-a0ff-605a-bdea-aff9e568f7fb',
  },
  staging: {
    FR: '1efc90ed-4aae-6e50-bdea-aff9e568f7fb',
    ES: '1efc90ef-9fd6-6002-bdea-aff9e568f7fb',
    IT: '1efc90ed-ac3e-6012-bdea-aff9e568f7fb',
    PT: '1efc90ef-a0ff-605a-bdea-aff9e568f7fb',
  },
  ppr: {
    FR: '1efdc9a0-c49d-636e-8167-3f73b3466a54',
    ES: '1efdc99e-e807-6fd6-8167-3f73b3466a54',
    IT: '1efdc9a0-c433-6662-8167-3f73b3466a54',
    PT: '1efdc9a0-c50f-6a0e-8167-3f73b3466a54',
  },
  prod: {
    FR: '1f01f893-4e68-6d3a-9aed-3dce1a1638f9',
    ES: '1f01f893-1fb3-6486-9aed-3dce1a1638f9',
    IT: '1f01f893-4c75-64ba-9aed-3dce1a1638f9',
    PT: '1f01f893-62cf-60e4-9aed-3dce1a1638f9',
  },
};
export const REACT_APP_GROUP_CONFIG = nationalPublicGroup[ENV];

export const apiExternal = {
  // API-TRADE
  getGroupUserInfos: {
    path: '/tradev2/user/me',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postTrade: {
    path: '/tradev2/import/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getCoverageRequest: {
    path: '/tradev2/coverage/search',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postSale: {
    path: '/tradev2/sales',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getSale: {
    path: '/tradev2/sale/{recordId}/{type}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getOffer: {
    path: '/tradev2/offers/{recordId}/{type}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  putSale: {
    path: '/admin/sale/{saleId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  putOffer: {
    path: '/tradev2/offers/{offerId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  postCounterOffer: {
    path: '/tradev2/offers',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  refuseOffersBySale: {
    path: '/tradev2/sales/refuse-all-offers/{id}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  postPartner: {
    path: '/tradev2/partner_requests',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getPartnerOffer: {
    path: '/tradev2/partner_requests/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  createPurchaseOrder: {
    path: '/tradev2/sales/{id}/purchase-orders',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  putPartnerOffer: {
    path: '/tradev2/acceptOffers/{partnerOfferId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getPickupSites: {
    path: '/tradev2/pickup-management-params',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postPickupSites: {
    path: '/tradev2/pickup-management',
    method: 'POST',
    url: apiCarcheck[ENV],
  },

  //old Trade calls
  putCounterOffer: {
    path: '/counterOffer/{uuid}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },

  getFormsApi: {
    path: '/inspection/records',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getFormApi: {
    path: '/inspection/records/{formId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postForm: {
    path: '/inspection/records/{formId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getRecordDetails: {
    path: '/buyer/record/{recordId}/details',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getVehiculeByVin: {
    path: '/car-details/vin/{vin}/{country}',
    method: 'GET',
    url: apiReferential[ENV],
  },
  getVehiculeByReg: {
    path: '/car-details/registration/{registration}/{country}',
    method: 'GET',
    url: apiReferential[ENV],
  },
  postOffer: {
    path: '/supervisor/offer/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getQuotation: {
    path: '/version/{versionId}/year/{dateMecYear}/mileage/{mileage}/quotation',
    method: 'GET',
    url: apiQuotation[ENV],
  },
  getQuotationByRegistration: {
    path: '/registration/{registration}/mileage/{mileage}/quotation',
    method: 'GET',
    url: apiQuotation[ENV],
  },
  updateFinalPrice: {
    path: '/buyer/record/{recordId}/final-price',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  updateStatus: {
    path: '/buyer/record/{recordId}/status/{status}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getSourceInfo: {
    path: '/sources/{sourceId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  searchRecord: {
    path: '/buyer/record/search',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  pushToDm: {
    path: '/buyer/record/{recordId}/expertise',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  postDm: {
    path: '/buyer/record/{recordId}/expertise/configuration',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getConcessions: {
    path: '/concessions',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postRecord: {
    path: '/buyer/{client}/appointment-record',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  updateAppointment: {
    path: '/buyer/appointment-record/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  updateRecord: {
    path: '/buyer/record/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  debrifeRecord: {
    path: '/buyer/record/{recordId}/debrief',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getPreference: {
    path: '/preference',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getRecordStatus: {
    path: '/buyer/record/{recordId}/status',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getToken: {
    path: '/auth?refresh=true',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  logout: {
    path: '/logout',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  refreshToken: {
    path: '/refresh',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  resetPassword: {
    path: '/password-reset',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  downloadPdf: {
    path: '/buyer/public/{recordKey}/admin-documents/{refHexaId}_rapport_d_inspection.pdf',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateReportInspection: {
    path: '/buyer/record/{recordId}/report',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getUsers: {
    path: '/carcheckusers',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateImage: {
    path: '/inspection/record/{formId}/documents',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  updateFinalisationImage: {
    path: '/buyer/record/{recordId}/documents/finalisation',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getFinalisationImages: {
    path: '/buyer/documents/finalisation/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getFrevoStat: {
    path: '/costs/refurbishment',
    method: 'GET',
    url: apiQuotation[ENV],
  },
  getReferential: {
    path: '/referential',
    method: 'GET',
    url: apiCostReferential[ENV],
  },
  getReferentialDetails: {
    path: '/referential/details',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  getReferentialUpdateDate: {
    path: '/referential/update/date',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postFormError: {
    path: '/postformerror',
    method: 'POST',
    url: apiPostError[ENV],
  },
  getUser: {
    path: '/users/{userID}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateRecordStatusApi: {
    path: '/buyer/record/{recordId}/status/expertise-started',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getListFromReferential: {
    path: '/',
    method: 'GET',
    url: apiReferential[ENV],
  },
  getUpdateAt: {
    path: '/buyer/record/{recordId}/updateAt',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  pushVincheck: {
    path: '/vincheck/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getVincheck: {
    path: '/vincheck/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateRecoveryOffer: {
    path: '/supervisor/recoveryOffer/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getPdfOfferReprise: {
    path: '/buyer/public/{recordKey}/{language}/admin-documents/report-offer-reprise.pdf',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateCustomerInfo: {
    path: '/buyer/record/{recordId}/customer',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getImage: {
    path: '/inspection/documents/{imageId}',
    method: 'GET',
    url: apiCarcheck[ENV],
    type: 'blob',
  },
  postAnswer: {
    path: '/inspection/records/question/{formId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getVersions: {
    path: '/make/{makeId}/model/{modelId}/versions',
    method: 'GET',
    url: apiReferential[ENV],
  },
  getPricingHistory: {
    path: '/track',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postReferencePricing: {
    path: '/{recordId}/coverage',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  putSupervisorInfos: {
    path: '/supervisor/data/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getConfigurationsDetails: {
    path: '/configurations/{id}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postBee2Link: {
    path: '/dms/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  lockPricing: {
    path: '/supervisor/lockPricing/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  unlockPricing: {
    path: '/supervisor/unlockPricing/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postCounterInspection: {
    path: '/counterInspection/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  removeCounterInspection: {
    path: '/counterInspection/{recordId}',
    method: 'DELETE',
    url: apiCarcheck[ENV],
  },
  getUserFeed: {
    path: '/userFeeds',
    method: 'GET',
    url: apiOffice[ENV],
  },
  getSources: {
    path: '/sources',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  createInspectionVersion: {
    path: '/inspection/version/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  getExternalRef: {
    path: '/externalRef/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postReportAi: {
    path: '/generate/monk/report/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  retriveHistovecInfo: {
    path: '/histovec/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getHistoryNrm: {
    path: '/nrm/history',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  postGuaranteedPrice: {
    path: '/nrm/request/guaranteed/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  putNrmStatus: {
    path: '/nrm/{recordId}/status/{nrmStatusId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  putMaintainedGuanranteed: {
    path: '/nrm/guaranteedMaintained/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  createCounterInspection: {
    path: '/buyer/counter-inspection',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getUserInfos: {
    path: '/me',
    method: 'GET',
    url: apiAccount[ENV],
  },
  getCarcheckUser: {
    path: '/user/auth/infos/{userKey}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  putFirmValuation: {
    path: '/nrm/stand-alone/notif/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  putNCOrderLink: {
    path: '/nrm/smart/valuation/{nrmRecordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
  createExternalProvider: {
    path: '/provider/records/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
  getVehiculeByRegAutotelex: {
    path: '/car-details/registration/{registration}/autotelex',
    method: 'GET',
    url: apiReferential[ENV],
  },
  getExternalProvider: {
    path: '/provider/records/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updateVehiculeByVin: {
    path: '/buyer/car-details/vin/{vin}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  greyCradReader: {
    path: '/grey-card-reader/{recordId}',
    method: 'POST',
    url: apiCarcheck[ENV],
  },
   getPackageMonkGenerate: {
    path: '/package/monk/{recordId}',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  updatePreferredLanguage: {
    path: '/users/{userId}',
    method: 'PUT',
    url: apiAccount[ENV],
  },
  getBuyersBySourceId: {
    path: '/carcheckusers',
    method: 'GET',
    url: apiCarcheck[ENV],
  },
  putBuyerExpertise: {
    path: '/admin/record/{recordId}',
    method: 'PUT',
    url: apiCarcheck[ENV],
  },
};

export const statusAT = {
  1: 'offline',
  2: 'online',
  3: 'sold',
  4: 'pending',
};

export const intervalGetRecordDetails = 10000; // 10 seconds
export const intervalGetVinCheck = 5000; // 5 seconds
export const reduxDataBases = {
  vincheck: 'redux.vincheck',
};

export const listPartner = {
  vpauto: 1,
  encheresVo: 2,
  alcopa: 3,
  mercier: 4,
};

export const popularBrands = [
  { id: -1, name: 'separator' },
  { id: 80, name: 'NISSAN' },
  { id: 81, name: 'OPEL' },
  { id: 64, name: 'FORD' },
  { id: 57, name: 'BMW' },
  { id: 76, name: 'MERCEDES' },
  { id: 55, name: 'AUDI' },
  { id: 92, name: 'VOLKSWAGEN' },
  { id: 619, name: 'DS AUTOMOBILES' },
  { id: 59, name: 'CITROEN' },
  { id: 82, name: 'PEUGEOT' },
  { id: 84, name: 'RENAULT' },
];

export const popularBrandsItaly = [
  { id: -1, name: 'separator' },
  { id: 231, name: 'DACIA' },
  { id: 91, name: 'TOYOTA' },
  { id: 63, name: 'FIAT' },
  { id: 57, name: 'BMW' },
  { id: 76, name: 'MERCEDES' },
  { id: 55, name: 'AUDI' },
  { id: 92, name: 'VOLKSWAGEN' },
  { id: 619, name: 'DS AUTOMOBILES' },
  { id: 59, name: 'CITROEN' },
  { id: 82, name: 'PEUGEOT' },
  { id: 84, name: 'RENAULT' },
];

export const clientsHideTabs = ['carcheck', 'gaap', 'ald'];

const domains = {
  dev: 'localhost',
  staging: '.shakazoola.com',
  ppr: '.autobiz.com',
  prod: '.autobiz.com',
};

export const domain = domains[ENV];

export const countries = {
  1: 'FR',
  2: 'DE',
  3: 'IT',
  4: 'BE',
  5: 'PL',
  6: 'AT',
  7: 'ES',
  8: 'PT',
  9: 'NL',
  10: 'FI',
  11: 'GR',
  12: 'HU',
  13: 'IE',
  14: 'NO',
  15: 'RO',
  16: 'UK',
  17: 'CZ',
  18: 'CH',
  19: 'SE',
  95: 'LU',
};

export const listVat = {
  REBU: 'REBU',
  yes_50percent: 'IVA 50%',
  yes_100percent: 'IVA 100%',
};

export const entryStockOptionVar = {
  0: 'today',
  15: 'in15Days',
  30: 'oneMonth',
  45: 'oneMonthAndHalf',
  60: 'twoMonth',
  75: 'twoMonthAndHalf',
  90: 'threeMonth',
  105: 'threeMonthAndHalf',
  120: 'fourMonth',
  135: 'fourMonthAndHalf',
  150: 'fiveMonth',
  165: 'fiveMonthAndHalf',
  180: 'sixMonth',
  195: 'sixMonthAndHalf',
  210: 'sevenMonth',
  225: 'sevenMonthAndHalf',
  240: 'eightMonth',
};

export const limitPricing = {
  1: 500,
  default: 100,
};

export const listCarPictures = [
  'back_picture',
  'door_left_front',
  'door_left_rear',
  'door_right_front',
  'door_right_rear',
  'front_picture',
  'left_side_picture',
  'right_side_picture',
  'three_quarters_back_left_picture',
  'three_quarters_back_picture',
  'three_quarters_front_picture',
  'three_quarters_front_right_picture',
  'wheels_back_right_picture',
  'wheels_back_left_picture',
  'wheels_front_right_picture',
  'wheels_front_left_picture',
];

export const vehInfoRequired = {
  DE: ['vin', 'brandId', 'modelId', 'registrationDate', 'gcDate', 'bodyId', 'fuelId', 'door', 'gearBoxId', 'ps'],
  default: [
    'registration',
    'vin',
    'brandId',
    'modelId',
    'registrationDate',
    'gcDate',
    'bodyId',
    'fuelId',
    'door',
    'gearBoxId',
    'ps',
  ],
};

export const didomiC = {
  name: 'autobizCarcheck',
  apiKey: 'cfad80dd-8fb6-43fa-a253-7156b52c2514',
  languages: process.env.REACT_APP_LANG,
  noticeId: 'Wy7JcC46',
};

export const sourcesFord = ['ford_ecommerce', 'ford_ecommerce_es', 'ford_ecommerce_it'];

export const privacyPolicy = {
  FR: 'politique-de-protection-des-donnees.html',
  ES: 'politica-de-confidencialidad.html',
  DE: 'datenschutzrichtlinie.html',
  EN: 'privacy-policy.html',
  IT: 'politica-sulla-riservatezza.html',
  PT: 'politica-de-privacidade.html',
  NL: 'politique-de-protection-des-donnees.html',
  BE: 'politique-de-protection-des-donnees.html',
  AT: 'politique-de-protection-des-donnees.html',
  default: 'politique-de-protection-des-donnees.html',
};

export const pagesToNotIndex = ['privacyPolicy'];

export const dmsStatusList = {
  1: 'dmsNotSend',
  2: 'dmsSendWithoutPictures',
  3: 'dmsSend',
};

const endPoint = {
  ppr: {
    key: 'h9c99r60Yh1ojBzdEvXmR1OfJ2fSvAdR6utXMHBc',
    url: 'https://ixnalykmsj.execute-api.eu-west-3.amazonaws.com/ppr/pdf',
  },
  prod: {
    key: 'EjAI0dU7RR8twh5d2tfyf5Cf9n6R3NdV6IuRYhrt',
    url: 'https://q93nw854nd.execute-api.eu-west-3.amazonaws.com/prod/pdf',
  },
};

const pdfCostUrls = {
  dev: endPoint.ppr,
  staging: endPoint.prod,
  ppr: endPoint.prod,
  prod: endPoint.prod,
};

export const pdfCostUrl = pdfCostUrls[ENV];

export const defaultProfile = ['b2c', 'b2b'];

export const decodeVinCountry = ['BE', 'AT', 'LU', 'DE'];

export const nrmFinalisationDocumentVar = {
  FR: 'nrmFinalisationDocumentDescriptionFr',
  DE: 'nrmFinalisationDocumentDescriptionDe',
  IT: 'nrmFinalisationDocumentDescriptionIt',
  BE: 'nrmFinalisationDocumentDescriptionBeLu',
  PL: 'nrmFinalisationDocumentDescription',
  AT: 'nrmFinalisationDocumentDescriptionAt',
  ES: 'nrmFinalisationDocumentDescriptionEs',
  PT: 'nrmFinalisationDocumentDescriptionPt',
  NL: 'nrmFinalisationDocumentDescriptionNl',
  FI: 'nrmFinalisationDocumentDescription',
  GR: 'nrmFinalisationDocumentDescription',
  HU: 'nrmFinalisationDocumentDescription',
  IE: 'nrmFinalisationDocumentDescription',
  NO: 'nrmFinalisationDocumentDescription',
  RO: 'nrmFinalisationDocumentDescription',
  UK: 'nrmFinalisationDocumentDescriptionUk',
  CZ: 'nrmFinalisationDocumentDescription',
  CH: 'nrmFinalisationDocumentDescription',
  SE: 'nrmFinalisationDocumentDescription',
  LU: 'nrmFinalisationDocumentDescriptionLu',
};

export const exclusionVehicleType = ['diplomatic_car', 'driving_school', 'tuning', 'car_with_driver', 'taxi'];

const auth0CredentialURL = {
  dev: { domain: 'stg-login-office.shakazoola.com', clientId: 'RdMMpdBJy1AnwoS4II65m8PxrbpIEtL1' },
  staging: { domain: 'stg-login-office.shakazoola.com', clientId: 'RdMMpdBJy1AnwoS4II65m8PxrbpIEtL1' },
  ppr: { domain: 'ppr-login-office.shakazoola.com', clientId: 'M1VUvG9E1yeWdBzFSM5Uq2O1rWKh8ryL' },
  // prod: { domain: 'autobiz-prd.eu.auth0.com', clientId: 'c3ChqUlufTbwD11LO54rsb4lrMJE6JmR' },
  prod: { domain: 'login-office.autobiz.com', clientId: 'c3ChqUlufTbwD11LO54rsb4lrMJE6JmR' },
};

const defaultImageIds = {
  dev: 185070,
  staging: 185070,
  ppr: 4421824,
  prod: 6687996,
};

export const defaultImage = defaultImageIds[ENV];

export const auth0Credentials = auth0CredentialURL[ENV];